import React from 'react';
import { Formatter, Grid, Badge } from 'framework-ui-components';
import PropTypes from 'prop-types';


class RigaOperazione extends React.Component {
  constructor(props) {
    super(props);

    this.vaiAOperazione = this.vaiAOperazione.bind(this);
  }

  vaiAOperazione() {
    const {
      item: {
        Id,
      },
    } = this.props;

    window.location.hash = `#/elaborazionemassiva/${Id}`;
  }

  render() {
    const {
      item: {
        Id,
        Servizio,
        Operazione,
        Indeterminata,
        Totale,
        Elaborati,
        InEsecuzione,
        DataInizio,
        DataFine,
      },
    } = this.props;
    return (
      <tr
        key={Id}
        onClick={this.vaiAOperazione}
      >
        <td>{Id} </td>
        <td>{Servizio}</td>
        <td>{Operazione}</td>
        <td>{InEsecuzione ? 'In corso' : 'Terminata' }</td>

        <td>
          {Indeterminata && '-'}
          {!Indeterminata && InEsecuzione && `${Math.floor((Elaborati / Totale) * 100)}%`}
        </td>

        <td>
          {DataInizio ? (
            <span>
              <Formatter
                tipo="date"
                valore={DataInizio}
              />
              {' - '}
              <Formatter
                tipo="hour"
                valore={DataInizio}
              />
            </span>
          ) : '-'}
        </td>
        <td>
          {DataFine ? (
            <span>
              <Formatter
                tipo="date"
                valore={DataFine}
              />
              {' - '}
              <Formatter
                tipo="hour"
                valore={DataFine}
              />
            </span>
          ) : '-'}
        </td>

      </tr>
    );
  }
}

RigaOperazione.propTypes = {
  item: PropTypes.object.isRequired,
};

export default RigaOperazione;
